import { isAxiosError } from 'axios';
import type { ApiError } from '../types/ApiError';

const SESSION_ERROR_CODES_403 = new Set([
  'NO_AXIIS_IDENTITY',
  'INACTIVE_AXIIS_IDENTITY',
  'AMBIGUOUS_AXIIS_IDENTITY',
]);

/** Extrai o envelope de erro do módulo (`04-spec-api-back.md` §8) de um erro do axios, se houver. */
export function parseApiError(error: unknown): ApiError | null {
  if (!isAxiosError(error) || !error.response) return null;
  const data = error.response.data;
  if (!data || typeof data !== 'object' || !('code' in data)) return null;
  return data as ApiError;
}

export function isSessionError(error: ApiError | null): boolean {
  return !!error && error.statusCode === 403 && SESSION_ERROR_CODES_403.has(error.code);
}

const KNOWN_ERROR_CODES = new Set([
  'INVALID_PERCENTAGE',
  'INVALID_COST_SHARE',
  'END_DATE_BEFORE_START_DATE',
  'OVERLAPPING_PERIOD',
  'PROJECT_OUT_OF_SCOPE',
  'PROJECT_NOT_ALLOCATABLE',
  'PROFESSIONAL_HAS_NO_ACTIVE_CONTRACT',
  'SALES_PROFILE_NOT_ALLOCATABLE',
  'INVALID_FINANCIAL_VALUE',
  'PROFESSIONAL_OUT_OF_SCOPE',
  'PROFESSIONAL_NOT_ALLOCATABLE',
  'SUM_ABOVE_100',
  'UNCONFIRMED_WARNINGS',
  'ALLOCATION_ALREADY_CLOSED',
  'ALLOCATION_NOT_FOUND',
  'EXPORT_TOO_LARGE',
  'TAG_NOT_FOUND',
  'TAG_NAME_TAKEN',
  'TAG_IN_USE',
  'TAG_INACTIVE',
  'INVALID_TAG_BATCH',
  'INVALID_MANAGER',
  'PROJECT_NOT_FOUND',
  'NO_AXIIS_IDENTITY',
  'INACTIVE_AXIIS_IDENTITY',
  'AMBIGUOUS_AXIIS_IDENTITY',
]);

/**
 * Chave i18n (namespace `alocacao`, `erros.*`) para um `code` do envelope.
 * Código desconhecido cai no genérico e vai pro console (`07-spec-front.md` §7) —
 * nunca mostra JSON cru.
 */
export function i18nKeyForError(code: string): string {
  if (!KNOWN_ERROR_CODES.has(code)) {
    console.error(`[allocation] unknown error code: ${code}`);
    return 'alocacao:erros.unknown';
  }
  const camel = code
    .toLowerCase()
    .replace(/_([a-z0-9])/g, (_, letter: string) => letter.toUpperCase());
  return `alocacao:erros.${camel}`;
}
